export enum ZoomableImageEvents {
    destroy = 'wheelzoom.destroy',
    load = 'load',
    mouseDown = 'mousedown',
    mouseMove = 'mousemove',
    mouseUp = 'mouseup',
    reset = 'wheelzoom.reset',
    wheel = 'wheel',
}
